export default "/build/images/1head.png?e6aed09cf31113e0a2d9a93b1178bcc2";